// extracted by mini-css-extract-plugin
export default {"toolbar":"toolbar_toolbar__q-Ri+","selectionGroup":"toolbar_selectionGroup__5xUJp","label":"toolbar_label__AQ3U3","selection":"toolbar_selection__4PrXW"};